export default {"src":"/_next/static/media/premium_support.833e584e.svg","height":256,"width":352,"blurWidth":0,"blurHeight":0};